/**
 * DMS Garage - URL Interception
 * Automatically applies saved vehicle filters to collection and search pages
 */

(function() {
  const GARAGE_STORAGE_KEY = 'dms_garage';
  const GLOBO_FILTERS = {
    make: 'gff_321501',
    model: 'gff_321502',
    series: 'gff_321503'
  };

  function getGarage() {
    try {
      const saved = localStorage.getItem(GARAGE_STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  }

  function buildGarageParams(garage) {
    const params = new URLSearchParams();
    if (garage.make) params.set(GLOBO_FILTERS.make, garage.make);
    if (garage.model) params.set(GLOBO_FILTERS.model, garage.model);
    if (garage.series) params.set(GLOBO_FILTERS.series, garage.series);
    return params;
  }

  function hasGarageParams(url) {
    const urlObj = new URL(url, window.location.origin);
    return urlObj.searchParams.has(GLOBO_FILTERS.make) ||
           urlObj.searchParams.has(GLOBO_FILTERS.model) ||
           urlObj.searchParams.has(GLOBO_FILTERS.series);
  }

  function isCollectionUrl(href) {
    return href && (href.includes('/collections/') || href.includes('/search'));
  }

  function appendGarageToUrl(href, garage) {
    const url = new URL(href, window.location.origin);
    const garageParams = buildGarageParams(garage);
    
    // Append garage params without overwriting existing ones
    for (const [key, value] of garageParams) {
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    }
    
    return url.toString();
  }

  // 1. Intercept clicks on collection links
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!isCollectionUrl(href)) return;

    const garage = getGarage();
    if (!garage) return;

    // Don't modify if already has garage params
    if (hasGarageParams(link.href)) return;

    e.preventDefault();
    window.location.href = appendGarageToUrl(link.href, garage);
  });

  // 2. Handle direct navigation (bookmarks, external links)
  function handleDirectNavigation() {
    const currentUrl = window.location.href;
    
    if (!isCollectionUrl(currentUrl)) return;
    if (hasGarageParams(currentUrl)) return;

    const garage = getGarage();
    if (!garage) return;

    // Redirect with garage params
    window.location.replace(appendGarageToUrl(currentUrl, garage));
  }

  // 3. Intercept search form submissions
  function interceptSearchForms() {
    const garage = getGarage();
    if (!garage) return;

    document.querySelectorAll('form[action="/search"]').forEach(form => {
      form.addEventListener('submit', function() {
        // Add hidden inputs for garage filters
        Object.entries(GLOBO_FILTERS).forEach(([key, param]) => {
          let input = form.querySelector(`input[name="${param}"]`);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = param;
            form.appendChild(input);
          }
          input.value = garage[key];
        });
      });
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      handleDirectNavigation();
      interceptSearchForms();
    });
  } else {
    handleDirectNavigation();
    interceptSearchForms();
  }

  // 4. Listen for garage changes in other tabs
  window.addEventListener('storage', function(e) {
    if (e.key === GARAGE_STORAGE_KEY) {
      // Garage was updated in another tab
      // Could optionally refresh or show notification
      console.log('Garage updated in another tab');
    }
  });
})();